export  const language_tr={
    "nav.home": "Ana Sayfa",
    "nav.cexs": "CEX'ler ve Çekirdek Takım",
    "nav.operations": "Operasyonlar",
    "nav.transactions": "İşlemler",
    "nav.blocks": "Bloklar",
    "nav.nodes": "Düğümler",
    "nav.stats": "İstatistikler",
    "stats.accounts": "Hesap Dağılımı",
    "stats.unlocks": "Pi Kilidini Açma (30 Gün)",
    "stats.monthly_unlocks": "Pi Kilidini Açma (Aylık)",
    'stats.domain_auction': 'Alan Adı Müzayedesi',
    "stats.largest_tx": "En Büyük İşlem",
"stats.migrate": "Ana Ağ Geçiş İstatistikleri",
    "search.placeholder": "Ara...",
    'operations.self_transfer': 'Kendi Hesabına Transfer',
    'operations.domain_auction': 'Alan Adı Müzayedesi',
    "operations.claim_claimable_balance": "π Talep Et",
    "operations.create_account": "Hesap Oluştur",
    "operations.payment": "Ödeme",
    "operations.path_payment_strict_receive": "Sıkı Alım Yolu ile Ödeme",
    "operations.path_payment_strict_send": "Sıkı Gönderim Yolu ile Ödeme",
    "operations.manage_sell_offer": "Satış Teklifini Yönet",
    "operations.create_passive_sell_offer": "Pasif Satış Teklifi Oluştur",
    "operations.set_options": "Seçenekleri Ayarla",
    "operations.change_trust": "Güveni Değiştir",
    "operations.allow_trust": "Güvene İzin Ver",
    "operations.account_merge": "Hesap Birleştirme",
    "operations.inflation": "Enflasyon",
    "operations.manage_data": "Verileri Yönet",
    "operations.bump_sequence": "Sıralamayı Artır",
    "operations.manage_buy_offer": "Alım Teklifini Yönet",
    "operations.create_passive_buy_offer": "Pasif Alım Teklifi Oluştur",
    "operations.create_claimable_balance": "Talep Edilebilir Bakiye Oluştur",
    "operations.claim_claimable_balance_atom": "Talep Edilebilir Bakiyeyi Talep Et",
    "operations.deposit": "Yatır",
    "operations.withdraw": "Çek",
    "operations.pay": "Öde",
    "operations.to": "Alıcı",
    "operations.from": "Gönderen",
    "operations.claimant": "Talep Sahibi",
    "operations.with_starting_balance": "Başlangıç Bakiyesi Dahil",
    "operations.claim": "Talep Et",
    "operations.heading": "Pi Ağ Blok Zincirindeki En Son Operasyonları Keşfedin",
    "operations.title": "Pi Ağındaki En Son Operasyonlar",
    "operations.description": "Pi Ağ blok zincirindeki en son operasyonları keşfedin.",
    "operations.source_account": "Kaynak Hesap",
    "operations.operation": "Operasyon",
    "operations.amount": "Miktar",
    "operations.tx": "İşlem",
    "operations.time": "Zaman",
    "pagination.previous": "Önceki",
    "pagination.next": "Sonraki",
    "pagination.page": "Sayfa",
    "account.title": "Hesap {{address}} - Pi Ağ Tarayıcısı",
    "account.heading": "Hesap Detayları",
    "account.heading_with_address": "Hesap {{address}}",
    "account.description": "Pi Ağ üzerindeki {{address}} hesabının detayları.",
    "account.loading": "Hesap detayları yükleniyor...",
    "account.not_found": "Hesap bulunamadı.",
    "account.scam_warning_title": "Dolandırıcılık Uyarısı",
    "account.scam_warning_description": "Topluluk raporlarına göre, bu cüzdan adresi güvenli değil olarak işaretlenmiştir. Dolandırıcılık, özel anahtar ihlali veya yetkisiz erişim ile ilişkili olabilir. İşlem yapmadan önce dikkatli olun.",
    "account.overview": "Genel Bakış",
    "account.available_balance": "Kullanılabilir Bakiye",
    "account.last_modified_time": "Son Değişiklik Zamanı",
    "account.locking": "Kilitli",
    "account.total_locking": "Toplam Kilitlenme ({{count}} öğe)",
    "account.next_unlock_time": "Sonraki Kilidin Açılma Zamanı",
    "account.claimable": "Talep Edilebilir",
    "account.amount": "Miktar",
    "account.number_of_items": "Öğe Sayısı",
    "account.over_100_items": "100'den Fazla Öğe",
    "account.tx_hash": "İşlem Hash'i",
    "account.operation_count": "Operasyon Sayısı",
    "account.fee": "Ücret",
    "account.created_at": "Oluşturulma Zamanı",
    "account.account": "Hesap",
    "account.effect": "Etkisi",
    "account.sponsor": "Sponsor",
    "account.predicate": "Koşul",
    "account.create_time": "Oluşturulma Zamanı",
    "account.latest_100_claimable": "En Son 100 Talep Edilebilir Bakiye",
    "account.tabs.operations": "Operasyonlar",
    "account.tabs.transactions": "İşlemler",
    "account.tabs.effects": "Etkiler",
    "account.tabs.claimable_balances": "Talep Edilebilir Bakiyeler",
    "effects.account_credited": "Hesap Alacaklandırıldı",
    "effects.account_debited": "Hesap Borçlandırıldı",
    "effects.account_created": "Hesap Oluşturuldu",
    "effects.claimable_balance_created": "Talep Edilebilir Bakiye Oluşturuldu",
    "effects.claimable_balance_claimed": "Talep Edilebilir Bakiye Talep Edildi",
    "effects.claimable_balance_claimant_created": "Talep Edilebilir Bakiye Talep Sahibi Oluşturuldu",
    "effects.account_removed": "Hesap Silindi",
    "effects.account_thresholds_updated": "Hesap Eşik Değerleri Güncellendi",
    "effects.account_home_domain_updated": "Hesap Ana Domaini Güncellendi",
    "effects.account.flags_updated": "Hesap Bayrakları Güncellendi",
    "effects.account_inflation_destination_updated": "Hesap Enflasyon Hedefi Güncellendi",
    "effects.signer_created": "İmza Yetkilisi Oluşturuldu",
    "effects.signer_removed": "İmza Yetkilisi Kaldırıldı",
    "effects.signer.updated": "İmza Yetkilisi Güncellendi",
    "effects.trustline_created": "Güven Hattı Oluşturuldu",
    "effects.trustline_removed": "Güven Hattı Kaldırıldı",
    "effects.trustline.updated": "Güven Hattı Güncellendi",
    "effects.trustline_authorized": "Güven Hattı Yetkilendirildi",
    "effects.trustline.deauthorized": "Güven Hattı Yetkilendirmesi Kaldırıldı",
    "effects.offer_created": "Teklif Oluşturuldu",
    "effects.offer_removed": "Teklif Kaldırıldı",
    "effects.offer.updated": "Teklif Güncellendi",
    "effects.trade": "Ticaret Gerçekleşti",
    "effects.data.created": "Veri Oluşturuldu",
    "effects.data.removed": "Veri Silindi",
    "effects.data.updated": "Veri Güncellendi",
    "effects.sequence_bumped": "Sıra Artırıldı",
    "effects.liquidity_pool_created": "Likidite Havuzu Oluşturuldu",
    "effects.liquidity_pool_removed": "Likidite Havuzu Kaldırıldı",
    "effects.liquidity_pool_deposited": "Likidite Havuzuna Para Yatırıldı",
    "effects.liquidity_pool_withdrew": "Likidite Havuzundan Para Çekildi",
    "effects.liquidity_pool_trade": "Likidite Havuzu Ticareti",
    "effects.liquidity_pool_revoked": "Likidite Havuzu İptal Edildi",
    "effects.contract_credited": "Sözleşme Alacaklandırıldı",
    "effects.contract_debited": "Sözleşme Borçlandırıldı",
    "effects.claimable_balance_sponsorship_removed": "Talep Edilebilir Bakiye Sponsorluğu Kaldırıldı",
    "account_stats.heading": "Pi Hesap İstatistikleri - Bakiye Dağılımı ve En Üst Hesaplar",
    "account_stats.title": "Pi Hesap İstatistikleri - Bakiye Dağılımı ve En Üst Hesaplar",
    "account_stats.description": "Pi ağındaki en zengin Pi hesaplarını ve genel bakiye dağılımını görün.",
    "account_stats.intro_text": "Tüm hesaplardaki Pi dağılımını keşfedin ve en üst Pi sahiplerini görün.",
    "account_stats.distribution_chart_title": "Pi Sahip Dağılımı",
    "account_stats.categories_title": "Dağılım Kategorileri",
    "account_stats.top_accounts_title": "En Üst Pi Hesapları",
    "account_stats.accounts": "hesaplar",
    "account_stats.of_total": "toplamın",
    "account_stats.table.category": "Kategori",
    "account_stats.table.balance_range": "Bakiye Aralığı",
    "account_stats.table.usd_value": "USD Değeri",
    "account_stats.table.accounts": "Hesap Sayısı",
    "account_stats.table.percentage": "Toplam Yüzdesi",
    "account_stats.table.total": "Toplam",
    "account_stats.table.rank": "Sıra",
    "account_stats.table.account": "Hesap",
    "account_stats.table.balance": "Bakiye",
    "account_stats.table.value": "Değer",
    "account_stats.table.supply_percentage": "Toplam Arz Yüzdesi",
    "account_stats.categories.whales": "Balinalar",
    "account_stats.categories.sharks": "Köpekbalıkları",
    "account_stats.categories.dolphins": "Yunuslar",
    "account_stats.categories.tunas": "Ton balıkları",
    "account_stats.categories.fish": "Balıklar",
    "account_stats.categories.shrimps": "Karidesler",
    "account_stats.categories.plankton": "Plankton",
    "account_stats.categories.microbes": "Mikroorganizmalar",
    "number.billion_short": "Milyar",
    "number.million_short": "Milyon",
    "number.thousand_short": "Bin",
    "common.loading": "Yükleniyor...",
    "common.sponsored": "Sponsorlu",
    "common.ad": "Reklam",
    "common.ad_not_available": "Bölgenizde sponsorlu içerik mevcut değil",
    "blocks.heading": "Pi Ağ Blok Zincirindeki En Son Blokları Keşfedin",
    "blocks.title": "Pi Ağındaki En Son Bloklar",
    "blocks.description": "Pi ağ blok zincirindeki en son blokları keşfedin.",
    "blocks.sequence": "Sıra",
    "blocks.hash": "Hash",
    "blocks.transactions": "İşlemler",
    "blocks.operations": "Operasyonlar",
    "blocks.time": "Zaman",
    "blocks.successful": "Başarılı",
    "blocks.failed": "Başarısız",
    "block.title": "Blok #{{sequence}} - Pi Ağ Tarayıcısı",
    "block.heading": "Blok #{{sequence}}",
    "block.description": "Pi ağ blok zincirindeki Blok #{{sequence}} detayları.",
    "block.loading": "Blok detayları yükleniyor...",
    "block.not_found": "Blok bulunamadı.",
    "block.information": "Blok Bilgisi",
    "block.hash": "Hash",
    "block.previous_hash": "Önceki Hash",
    "block.sequence": "Sıra",
    "block.time": "Zaman",
    "block.total_coins": "Toplam Coin",
    "block.fee_pool": "Ücret Havuzu",
    "block.base_fee": "Temel Ücret",
    "block.base_reserve": "Temel Rezerv",
    "block.protocol_version": "Protokol Sürümü",
    "block.tx_hash": "İşlem Hash'i",
    "block.operation_count": "Operasyon Sayısı",
    "block.fee": "Ücret",
    "block.created_at": "Oluşturulma Zamanı",
    "block.tabs.transactions": "İşlemler",
    "block.tabs.operations": "Operasyonlar",
    "block.tabs.effects": "Etkiler",
    "cex.heading": "CEX ve Çekirdek Takım Hesap İstatistikleri",
    "cex.title": "Pi Ağındaki CEX ve Çekirdek Takım Hesapları",
    "cex.description": "Pi ağ blok zincirindeki CEX ve çekirdek takım hesaplarını keşfedin.",
    "cex.wallet_balances": "CEX Cüzdan Bakiyeleri",
    "cex.core_team_wallets": "Pi Çekirdek Takım Cüzdanları",
    "cex.cmc_ranking": "CMC Sıralaması",
    "cex.exchange": "Borsa",
    "cex.chart_link": "Grafik Bağlantısı",
    "cex.signup_link": "Kayıt Bağlantısı",
    "cex.wallet_address": "Cüzdan Adresi",
    "cex.balance_pi": "Bakiye (Pi)",
    "cex.balance_usd": "Bakiye (USD)",
    "cex.chart": "Grafik",
    "cex.signup": "Kayıt Ol",
    "cex.total": "Toplam",
    "cex.note": "Not",
    "cex.pi_foundation": "Pi Vakfı",
    "cex.team_wallet_footnote": "Çok sayıda hesap ve çok az işlem nedeniyle, burada Pi çekirdek takımına ait olduğu işaretlenmiş yaklaşık 10.000 hesap listelenmemiştir. Her cüzdan yaklaşık 2.000.000 Pi tutmakta olup, toplamda yaklaşık 20 milyar Pi hesaplanmamıştır.",
   'cex.total_in': 'Toplam Giriş (son 24 saat)',
'cex.total_out': 'Toplam Çıkış (son 24 saat)',
'cex.net_difference': 'Net Akış (son 24 saat)',
'cex.flow_data_updated': 'Veriler her 30 dakikada bir güncellenir',
'cex.flow_note': 'Veriler son 24 saati kapsamaktadır ve her 30 dakikada bir otomatik olarak güncellenir.',
    "contact.heading": "Bize Ulaşın",
    "contact.title": "PiScan ile İletişime Geçin",
    "contact.description": "Herhangi bir sorunuz veya geri bildiriminiz varsa, lütfen PiScan ile iletişime geçin.",
    "contact.intro_text": "Sorularınız varsa, aşağıdaki yolla bizimle iletişime geçin",
    "contact.success_message": "Bize ulaştığınız için teşekkürler! En kısa sürede size dönüş yapacağız.",
    "contact.form.name": "Adınız",
    "contact.form.email": "E-posta Adresiniz",
    "contact.form.message": "Mesaj",
    "contact.form.submit": "Mesaj Gönder",
    "home.heading": "Pi Ağ İşlemlerini, Cüzdanlarını ve İstatistiklerini Keşfedin",
    "home.title": "Pi Ağ İşlemlerini, Cüzdanlarını ve İstatistiklerini Keşfedin",
    "home.description": "Pi ağ işlemlerini, cüzdanlarını ve istatistiklerini keşfedin",
    "home.market_cap": "Piyasa Değeri",
    "home.price": "Fiyat",
    "home.24h_change": "24 Saat Değişim",
    "home.pi_supply": "Pi Arzı",
    "home.circulating": "Dolaşımdaki",
    "home.locked": "Kilitli",
    "home.cex_balance_total": "CEX Bakiyesi (Toplam)",
    "home.view_all": "Tümünü Gör",
    "home.network_stats": "Ağ İstatistikleri",
    "home.blocks": "Bloklar",
    "home.tps": "TPS",
    "home.latest_transactions": "En Son İşlemler",
    "home.signature": "İmza",
    "home.time": "Zaman",
    "home.block": "Blok",
    "home.ops": "Operasyonlar",
    "home.latest_operations": "En Son Operasyonlar",
    "home.source_account": "Kaynak Hesap",
    "home.operation": "Operasyon",
    "home.amount": "Miktar",
    "home.tx": "İşlem",
    "nodes.heading": "Pi Ağ Düğümler Haritası ve Ağ İstatistikleri",
    "nodes.title": "Pi Ağ Düğümleri ve Doğrulayıcılar",
    "nodes.description": "Pi ağ düğümlerini, doğrulayıcıları ve ağ topolojisini keşfedin. Düğümlerin küresel dağılımını ve bağlantılarını görün.",
    "nodes.active_nodes": "Aktif Düğümler",
    "nodes.validators": "Doğrulayıcılar",
    "nodes.known_peers": "Bilinen Eşler",
    "nodes.disconnected_nodes": "Bağlantısı Kesilmiş Düğümler",
    "nodes.network_graph": "Ağ Grafiği",
    "nodes.node_types": "Düğüm Türleri",
    "nodes.validator": "Doğrulayıcı",
    "nodes.watcher": "İzleyici",
    "nodes.disconnected_private": "Bağlantısı Kesilmiş/Özel",
    "nodes.click_to_highlight": "Bağlantıları vurgulamak için düğüme tıklayın",
    "nodes.global_distribution": "Küresel Dağılım",
    "nodes.mapped_nodes": "Haritalanmış Düğümler",
    "nodes.node_details": "Düğüm Detayları",
    "nodes.nodes": "Düğümler",
    "nodes.address": "Adres",
    "nodes.type": "Tür",
    "nodes.location": "Konum",
    "nodes.isp": "İnternet Servis Sağlayıcısı",
    "nodes.version": "Sürüm",
    "nodes.trust": "Güven",
    "nodes.trusted_by": "Güvenilen",
    "nodes.status": "Durum",
    "nodes.status.connected": "Bağlı",
    "nodes.status.disconnected": "Bağlantısı Kesilmiş",
    "nodes.status.private": "Özel",
    "nodes.active_quorum_sets": "Aktif Oy Birliği Setleri",
    "nodes.active": "Aktif",
    "nodes.quorum_hash": "Oy Birliği Hash'i",
    "nodes.node_id": "Düğüm ID'si",
    "nodes.unknown": "Bilinmiyor",
    "nodes.core_team": "Çekirdek Takım",
    "nodes.tooltip.node_id": "Düğüm ID'si",
    "nodes.tooltip.address": "Adres",
    "nodes.tooltip.type": "Tür",
    "nodes.tooltip.status": "Durum",
    "nodes.tooltip.version": "Sürüm",
    "nodes.tooltip.location": "Konum",
    "nodes.tooltip.not_accessible": "Erişilemiyor",
    "report_scam.heading": "Dolandırıcılık Cüzdanını Bildir",
    "report_scam.title": "PiScan'de Dolandırıcılık Cüzdanını Bildir",
    "report_scam.description": "Dolandırıcılık veya sahtekarlık faaliyetiyle ilişkili cüzdan adresini bildirin.",
    "report_scam.intro_text": "Dolandırıcılık veya sahtekarlık faaliyetiyle ilişkili şüpheli bir cüzdan adresiyle karşılaştıysanız, lütfen aşağıdaki formu doldurarak bildirin. Ekibimiz gönderinizi inceleyecek ve dolandırıcılık olarak doğrulanırsa, topluluğu uyarmak amacıyla PiScan'de ilgili cüzdanı 'Dolandırıcılık' olarak işaretleyecektir.",
    "report_scam.success_message": "Bildiriminiz için teşekkürler! Ekibimiz en kısa sürede inceleyecektir.",
    "report_scam.form.wallet_address": "Cüzdan Adresi",
    "report_scam.form.wallet_placeholder": "Dolandırıcılık cüzdan adresini girin",
    "report_scam.form.reason": "Bildirim Nedeni",
    "report_scam.form.reason_placeholder": "Bu cüzdanın neden dolandırıcılıkla ilişkili olduğuna dair açıklama yapın",
    "report_scam.form.email": "E-posta Adresiniz (Opsiyonel)",
    "report_scam.form.email_placeholder": "E-posta adresinizi girin (opsiyonel)",
    "report_scam.form.email_note": "Daha fazla bilgi için sizinle iletişime geçebiliriz.",
    "report_scam.form.submit": "Bildirimi Gönder",
    "transaction.title": "Pi Ağındaki İşlem #{{id}}",
    "transaction.heading": "İşlem Detayları",
    "transaction.description": "Pi ağ blok zincirindeki İşlem #{{id}} detayları.",
    "transaction.loading": "İşlem detayları yükleniyor...",
    "transaction.not_found": "İşlem bulunamadı.",
    "transaction.hash": "Hash",
    "transaction.ledger_block": "Defter (Blok)",
    "transaction.result": "Sonuç",
    "transaction.source_account": "Kaynak Hesap",
    "transaction.fee_account": "Ücret Hesabı",
    "transaction.fee": "Ücret",
    "transaction.operation_count": "Operasyon Sayısı",
    "transaction.summary": "Özet",
    "transaction.operations": "Operasyonlar",
    "transaction.effects": "Etkiler",
    "transaction.account": "Hesap",
    "transaction.operation": "Operasyon",
    "transaction.effect": "Etki",
    "transaction.amount": "Miktar",
    "transaction.successful": "Başarılı",
    "transaction.failed": "Başarısız",
    "transaction.loading_details": "İşlem detayları yükleniyor...",
    "transaction.with_operations": "{{count}} adet operasyon içeren işlem",
    "transaction.core_team_distributed": "Pi Çekirdek Takım tarafından dağıtıldı",
    "transaction.to": "Alıcı",
    "transaction.accounts": "Hesaplar",
    "transaction.locked_for_days": ", {{days}} gün kilitli",
    "transaction.locked_range_days": ", kilit süresi {{minDays}} günden {{maxDays}} güne kadar değişiyor",
    "transaction.created_at": "Oluşturulma Zamanı",
    "unlock_stats.heading": "Pi Kilidini Açma İstatistikleri - Önümüzdeki 30 Gün",
    "unlock_stats.title": "Pi Kilidini Açma İstatistikleri - Önümüzdeki 30 Gün",
    "unlock_stats.description": "Önümüzdeki 30 gün için Pi kripto paranın kilidini açma tahminlerini görün.",
    "unlock_stats.intro_text": "Önümüzdeki 30 gündeki Pi kilidinin açılması, talep edilebilir bakiyeye dayanmaktadır – bu bakiye kullanıcı tarafından kilitlenmiş veya Pi Çekirdek Takım tarafından dağıtılmış olabilir. Henüz talep edilebilir bakiyeye dahil olmayan yayınlanmamış Pi takip edilemez. Lütfen düzenli olarak güncellemeleri kontrol edin. Tüm zamanlar UTC'dir.",
    "unlock_stats.today_note": "Bugünkü kilidini açma miktarı, şuan itibariyle gün sonuna (UTC) kadar açılacak kalan Pi'yi temsil eder.",
    "unlock_stats.updated_at": "Veri güncellendi:",
    "unlock_stats.unknown": "Bilinmiyor",
    "unlock_stats.total_locked": "Toplam Kilitli Pi",
    "unlock_stats.total_next_30": "Önümüzdeki 30 Gün İçin Toplam Kilidini Açma",
    "unlock_stats.of_total_locked": "toplam kilitli miktarın",
    "unlock_stats.avg_daily": "Ortalama Günlük Kilidini Açma",
    "unlock_stats.per_day": "günlük",
    "unlock_stats.highest_day": "En Yüksek Kilidini Açma Günü",
    "unlock_stats.on": "tarihinde",
    "unlock_stats.chart_title": "Pi Kilidini Açma Grafiği - Önümüzdeki 30 Gün",
    "unlock_stats.data_table": "Kilidini Açma Veri Tablosu",
    "unlock_stats.date": "Tarih",
    "unlock_stats.amount": "Miktar",
    "unlock_stats.value": "Değer",
    "unlock_stats.pi_unlock": "Pi Kilidini Açma",
    "unlock_stats.y_axis_label": "Pi Kilidini Açma (milyon cinsinden)",
    "unlock_stats.monthly_heading": "Aylık Pi Kilit Açma İstatistikleri",
    "unlock_stats.monthly_title": "Aylık Pi Kilit Açma İstatistikleri",
    "unlock_stats.total_next_12": "Önümüzdeki 12 Ay İçin Toplam Kilidini Açma",
    "unlock_stats.monthly_description": "Aylara göre Pi kripto para kilit açma istatistiklerini görüntüleyin",
    "unlock_stats.monthly_intro_text": "Aylık Pi kripto para kilit açma istatistiklerini görüntüleyin.",
    "unlock_stats.monthly_note": "İstatistikler uygun kilit açma taleplerine dayanmaktadır.",
    "unlock_stats.monthly_chart_title": "Aylık Pi Kilit Açma İstatistikleri Grafiği",
    "unlock_stats.total_forecast": "Toplam İstatistik",
    "unlock_stats.monthly_data_table": "Aylık Kilit Açma Verileri",
    "unlock_stats.total_locking": "Toplam Kilitlenen Miktar",
    "unlock_stats.avg_monthly": "Aylık Ortalama",
    "unlock_stats.highest_month": "En Yüksek Ay",
    "unlock_stats.per_month": "ay başına",
    "unlock_stats.in": "içinde",
    "unlock_stats.month": "Ay",
    "unlock_stats.view_daily": "Günlük Kilit Açma İstatistiklerini Görüntüle",
    "unlock_stats.view_monthly": "Aylık Kilit Açma İstatistiklerini Görüntüle",
    "common.loading_error": "Veriler yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.",

    "transactios.heading": "Pi Ağı Blok Zincirindeki En Son İşlemleri Keşfedin",
    "transactions.title": "Pi Ağındaki En Son İşlemler",
    "transactions.description": "Pi ağ blok zincirindeki en son işlemleri keşfedin.",
    "domain_auction_stats.heading": "Pi Alan Adı Açık Artırma İstatistikleri",
"domain_auction_stats.title": "Pi Alan Adı Açık Artırma İstatistikleri | Pi Ağ İstatistikleri",
"domain_auction_stats.description": "Pi Ağı alan adı açık artırmalarının analizini gösterir, farklı fiyat aralıklarındaki teklif dağılımını ve şimdiye kadar teklif edilen toplam Pi miktarını sunar.",
"domain_auction_stats.intro_text": "Bu sayfa, Pi alan adı açık artırmalarına ilişkin analizler sunar ve farklı fiyat aralıklarındaki teklif dağılımını vurgular.",
"domain_auction_stats.last_updated": "Son Güncelleme",
"domain_auction_stats.summary_title": "Açık Artırma Teklif Özeti",
"domain_auction_stats.total_bids": "Toplam Teklif Sayısı",
"domain_auction_stats.total_pi_bid": "Şimdiye Kadar Teklif Edilen Toplam Pi",
"domain_auction_stats.estimated_value": "Tahmini Değer (USD)",
"domain_auction_stats.pi_price": "Güncel Pi Fiyatı",
"domain_auction_stats.distribution_title": "Teklif Dağılımı",
"domain_auction_stats.chart_title": "Teklif Fiyat Dağılımı",
"domain_auction_stats.details_title": "Canlı Teklif Ayrıntıları",
"domain_auction_stats.bids": "teklifler",
"domain_auction_stats.of_total": "toplam teklifler içinde",
"domain_auction_stats.bid_count": "Teklif Sayısı",
"domain_auction_stats.ranges.low": "Düşük Teklifler",
"domain_auction_stats.ranges.medium": "Standart Teklifler",
"domain_auction_stats.ranges.high": "Premium Teklifler",
"domain_auction_stats.ranges.premium": "Lüks Teklifler",
"domain_auction_stats.ranges.elite": "Elit Teklifler",
"domain_auction_stats.table.price_range": "Teklif Fiyat Aralığı",
"domain_auction_stats.table.bid_count": "Teklif Sayısı",
"domain_auction_stats.table.percentage": "Yüzde",
"domain_auction_stats.table.total": "Toplam Teklifler",
"domain_auction_stats.highest_bid": "En Yüksek Teklif",
"domain_auction_stats.top_bids_title": "En Yüksek Teklifler",
"domain_auction_stats.table.account": "Hesap",
"domain_auction_stats.table.bid_amount": "Teklif Miktarı",
"domain_auction_stats.table.usd_value": "USD Değeri",

"largest_tx.heading": "En Büyük Pi İşlemleri (Son 24 Saat)",
"largest_tx.title": "Son 24 Saat İçindeki En Büyük Pi İşlemleri - PiScan",
"largest_tx.description": "Son 24 saat içinde Pi Network blok zincirindeki en büyük Pi işlemlerini keşfedin.",
"largest_tx.list_heading": "Miktara Göre En Büyük İşlemler (Son 24 Saat)",
"largest_tx.rank": "Sıralama",
"largest_tx.transaction": "İşlem",
"largest_tx.account": "Hesap",
"largest_tx.amount": "Miktar (π)",
"largest_tx.date": "Tarih & Saat",
"largest_tx.no_data": "Son 24 saat içinde işlem verisi bulunmamaktadır.",
"largest_tx.fetch_error": "İşlem verisi alınamadı.",
"largest_tx.loading": "En büyük işlemler yükleniyor...",
"largest_tx.largest_amount": "En Büyük İşlem Miktarı (Son 24 Saat)",
"largest_tx.latest_large_tx": "En Son Büyük İşlem (Son 24 Saat)",
"largest_tx.total_value": "Toplam Değer (İlk 100 İşlem, Son 24 Saat)",

"migrate_stats.heading": "Pi Geçiş İstatistikleri",
"migrate_stats.title": "Pi Ana Ağa Geçiş İstatistikleri - PiScan",
"migrate_stats.description": "Son günlerde Pi’nin ana ağa geçişine dair günlük istatistikleri takip edin.",
"migrate_stats.last_updated": "Son Güncelleme",

"migrate_stats.daily_migration": "Günlük Geçiş Hacmi",
"migrate_stats.daily_stats": "Güne Göre Geçiş İstatistikleri",
"migrate_stats.loading": "Geçiş istatistikleri yükleniyor...",
"migrate_stats.no_data": "Geçiş verisi bulunmamaktadır.",
"migrate_stats.fetch_error": "Geçiş verisi alınamadı.",
"migrate_stats.date": "Tarih",
"migrate_stats.amount": "Miktar (π)",
"migrate_stats.percentage": "Yüzde (%)",
"migrate_stats.total": "Toplam",
"migrate_stats.pi_migrated": "Toplam Geçirilen Pi",
"migrate_stats.date_label": "Tarih: {{date}}",
"migrate_stats.usd_value": "USD Değeri",
"migrate_stats.at_price": "mevcut fiyat üzerinden",
"migrate_stats.current_price_note": "USD değerleri mevcut Pi fiyatı {{price}} π başına hesaplanmıştır.",
    "transactions_filter.heading": "İşlemleri Filtrele",
"transactions_filter.title": "İşlemleri Filtrele | Pi Scan",
"transactions_filter.description": "Adres, tutar ve diğer kriterlere göre Pi Network işlemlerini filtreleyin ve arayın.",
"transactions_filter.address_required_error": "Adres zorunludur.",
"transactions_filter.min_amount_required_error": "En az tutar girilmelidir.",
"transactions_filter.amount_too_low_error": "Tutar 10.000’dan az olamaz.",
"transactions_filter.min_exceeds_max_error": "En az tutar, en fazla tutarı aşamaz.",
"transactions_filter.filter_options": "Filtre Seçenekleri",
"transactions_filter.address": "Adres",
"transactions_filter.address_placeholder": "Hesap adresini girin",
"transactions_filter.min_amount": "En Az Tutar (Pi)",
"transactions_filter.min_amount_placeholder": "örn. 10000",
"transactions_filter.max_amount": "En Fazla Tutar (Pi)",
"transactions_filter.max_amount_placeholder": "örn. 100000",
"transactions_filter.apply_filters": "Uygula",
"transactions_filter.clear": "Temizle",
"transactions_filter.no_results": "Kriterlerinize uygun işlem bulunamadı.",
"transactions_filter.results": "Sonuçlar",
"transactions_filter.table.hash": "İşlem Hash’i",
"transactions_filter.table.time": "Zaman",
"transactions_filter.table.from": "Gönderen",
"transactions_filter.table.to": "Alıcı",
"transactions_filter.table.amount": "Tutar (Pi)",
"transactions_filter.apply_filters_prompt": "Sonuçları görmek için lütfen filtreleri uygulayın."
}